export interface HotkeysBindings {
  keys: string[];
  ctrl: boolean;
  meta: boolean;
}

export interface ButtonConfiguration {
  value: number;
}
